import React from 'react'
import { Element } from 'react-scroll'
import SectionTitle2 from '../sectionTitle/SectionTitle2'
import { Link } from 'react-router-dom'

const HomeAppliedAISolutions = () => {
  const appliedAISolutions = [
    {
      icon: "layers",
      title: "Recommendation Systems",
      description: "Personalizing user experiences with intelligent content and product suggestions.",
      link: "agriculture",
    },
    {
      icon: "chart",
      title: "Predictive Analytics",
      description: "Forecasting trends and outcomes using historical data and machine learning algorithms.",
      link: "energy",
    },
    {
      icon: "magnifying-glass",
      title: "Anomaly Detection",
      description: "Identifying outliers and unusual patterns in data to prevent issues before they occur.",
      link: "manufacturing",
    },
    {
      icon: "brain",
      title: "Generative AI",
      description: "Creating new content, designs, and solutions using advanced AI models.",
      link: "healthcare",
    },
    {
      icon: "database",
      title: "Knowledge Mining",
      description: "Extracting valuable insights from unstructured data and corporate documents.",
      link: "maritime",
    },
    {
      icon: "message",
      title: "Sentiment Analysis",
      description: "Analyzing customer feedback and social media to gauge public opinion and satisfaction.",
      link: "public-sector",
    },
  ]
  return (
    <>
      <Element
        name="HomeAppliedAISolutions"
        className="datatalent-section-gap mea-key-features"
      >
        <div className="container inner about-feature-list">
          <div className="row g-5">
            <div className="col-12 mt-0 px-0 px-md-4">
              <SectionTitle2
                classes = "text-center"
                title = "Applied AI Solutions"
              />
            </div>
            <div className="col-12 mt-4 px-0 px-md-4">
              <p className="text-center section-description">Revolutionizing Industries with Innovative AI solutions and comprehensive AI expertise spanning Predictive Analytics, Generative AI, Anomaly Detection, Sentiment Analysis, Recommendation Systems, Natural Language Processing, Knowledge Mining and beyond.</p>
            </div>
            {appliedAISolutions.map((solution) => <div className="col-12 col-lg-4 px-0 px-md-4 mt-4 mt-md-5" key={solution.title}>
              <div className="home-applied-ai-solutions-card p-4 h-100">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/${solution.icon}.svg`} alt={solution.icon} />
                </div>
                <h5 className="mt-3 mb-3">{solution.title}</h5>
                <p>{solution.description}</p>
                <Link className="d-flex flex-row align-items-center justify-content-start gap-2 home-links" to={`/solutions/${solution.link}`}>Learn more<i className="icon-arrow-right-line-right"></i></Link>
              </div>
            </div>)}
          </div>
        </div>
      </Element>
    </>
  )
}

export default HomeAppliedAISolutions;